import ListCardGrid from '@/components/lists/ListCardGrid';
import type { ListCard } from '@/components/lists/types';

/**
 * Página de exemplo (design Lovable — mosaico 2×2).
 * Rota: `/demo/minha-colecao-listas`
 */
const mockLists: ListCard[] = [
    {
        id: '1',
        name: 'Leituras da semana',
        description: 'Tudo que estou acompanhando agora.',
        isPrivate: false,
        worksCount: 12,
        followers: 48,
        covers: [
            'https://picsum.photos/seed/a1/300/400',
            'https://picsum.photos/seed/a2/300/400',
            'https://picsum.photos/seed/a3/300/400',
            'https://picsum.photos/seed/a4/300/400',
        ],
    },
    {
        id: '2',
        name: 'Lista privada de teste',
        description: 'Só eu vejo.',
        isPrivate: true,
        worksCount: 3,
        followers: 0,
        covers: ['https://picsum.photos/seed/b1/300/400', 'https://picsum.photos/seed/b2/300/400'],
    },
    {
        id: '3',
        name: 'Mais de quatro obras',
        description: 'Quarto tile com contador.',
        isPrivate: false,
        worksCount: 9,
        followers: 1,
        covers: [
            'https://picsum.photos/seed/c1/300/400',
            'https://picsum.photos/seed/c2/300/400',
            'https://picsum.photos/seed/c3/300/400',
            'https://picsum.photos/seed/c4/300/400',
        ],
    },
    {
        id: '4',
        name: 'Lista vazia',
        isPrivate: false,
        worksCount: 0,
        followers: 0,
        covers: [],
    },
    {
        id: '5',
        name: 'Uma capa só',
        isPrivate: false,
        worksCount: 7,
        followers: 3,
        covers: ['https://picsum.photos/seed/e1/300/400'],
    },
    {
        id: '6',
        name: 'Sem descrição pública',
        isPrivate: false,
        worksCount: 2,
        followers: 120,
        covers: ['https://picsum.photos/seed/f1/300/400', 'https://picsum.photos/seed/f2/300/400'],
    },
];

export default function MinhaColecao() {
    return (
        <div className="min-h-screen bg-[#0a0a0a] px-4 py-10 text-white md:px-8">
            <div className="mx-auto max-w-6xl">
                <h1 className="mb-2 text-2xl font-bold tracking-tight">Demo — cards de lista (mosaico)</h1>
                <p className="mb-8 text-sm text-white/50">Rota de preview; integração real em Coleção → Listas.</p>
                <ListCardGrid lists={mockLists} onOpenList={(id) => console.info('abrir lista', id)} />
            </div>
        </div>
    );
}
